// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O6sm","rootMobile":"styles_rootMobile__2lXxK"};